export default {
  nav: {
    dashboard: 'Dashboard',
    myHabits: 'My Habits',
    calendar: 'Calendar',
    stats: 'Stats'
  },
  common: {
    search: 'Search habits...',
    addHabit: '+ Add Habit',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    saveChanges: 'Save Changes',
    noDays: 'no days',
    noReminders: 'No reminders',
    noHabitsYet: 'No habits yet',
    noHabitsYetAdd: 'No habits yet. Go to My Habits to add one!',
    noHabitsForToday: 'No habits for today',
    description: 'Description',
    noDescription: 'No description',
    createdAt: 'Created At'
  },
  settings: {
    title: 'Settings',
    welcome: 'Welcome',
    stranger: 'Stranger',
    clickAvatar: 'Click avatar to change',
    enterName: 'Enter your name',
    notification: 'Notification',
    language: 'Language',
    theme: 'Theme',
    feedback: 'Feedback',
    usernameExceed: 'Username cannot exceed 10 characters'
  },
  language: {
    english: 'ENGLISH',
    chinese: 'CHINESE'
  },
  habitForm: {
    addTitle: 'Add Habit',
    editTitle: 'Edit Habit',
    name: 'Name',
    namePlaceholder: 'e.g., Morning Exercise, Reading',
    description: 'Description',
    descriptionPlaceholder: 'e.g., Exercise for 30 minutes every morning at 6 AM',
    daysPerWeek: 'Days/Week',
    reminders: 'Reminders',
    hour: 'Hour',
    min: 'Min',
    enterHabitName: 'Please enter a habit name',
    selectReminder: 'Please select a reminder time',
    selectDay: 'Please select at least one day'
  },
  dashboard: {
    todayTab: 'Today',
    weekTab: 'Week',
    export: 'Export',
    exportSuccess: 'Data exported successfully!',
    todayCheckin: 'Today Check-in',
    todayFocus: 'Focus on today, build good habits!',
    todayCompleted: 'Today Completed',
    status: 'Status',
    checked: 'Checked',
    unchecked: 'Unchecked',
    suggestedTime: 'Suggested Time',
    weekly: 'Weekly',
    days: 'days',
    keepGoing: 'Keep going!',
    canOnlyCheckToday: 'Can only check off today\'s habits',
    tooEarly: 'Too early. Reminder is at {time}, please check in after {after}',
    tooLate: 'Too late. Reminder was at {time}, please check in before {before}',
    timeToTrack: 'Time to track: {habits}!',
    timeToTrackMultiple: 'Time to track {count} habits: {habits}!'
  },
  calendar: {
    noHabits: 'No habits yet. Go to My Habits to add one!'
  },
  stats: {
    selectHabit: 'Select Habit',
    allHabits: 'All Habits',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    last90Days: 'Last 90 Days',
    last365Days: 'Last 365 Days',
    currentStreak: 'Current Streak',
    completionRate: 'Completion Rate',
    totalCheckins: 'Total Checkins',
    completionTrend: 'Completion Trend',
    habitHeatmap: 'Habit Heatmap',
    completionRatio: 'Completion Ratio',
    habitRankings: 'Habit Rankings',
    noHabitsYet: 'No habits yet',
    overallStats: 'Overall statistics for all habits'
  },
  feedback: {
    title: 'Feedback',
    firstTimeTitle: 'First Time Use',
    firstTimeDesc: 'On first submission, an activation email will be sent to the admin email. Please confirm activation to enable future submissions.',
    limits: 'Limits: Max 3 submissions per day, 60 seconds between submissions',
    placeholder: 'Please share your feedback with us. We value every input!',
    emailLabel: 'Your Email (Optional)',
    emailPlaceholder: 'So we can contact you regarding your feedback',
    send: 'Send',
    sending: 'Sending...',
    success: 'Feedback sent successfully! Thank you for your input.',
    failed: 'Failed to send. Please try again later.',
    enterFeedback: 'Please enter your feedback',
    minLength: 'Feedback must be at least 10 characters long',
    tooManyUrls: 'Feedback cannot contain more than 2 URLs',
    waitSeconds: 'Please wait {seconds} seconds before submitting again',
    dailyLimit: 'You have reached the daily submission limit ({limit} submissions per day)'
  },
  days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
}
